/**
 * Thème PrimeVue personnalisé - aligné sur la charte Prix du Marché.
 *
 * Override le preset Aura pour utiliser :
 *  - primary : or bronze (--primary-500 = #C3A363)
 *  - secondary : noir (--secondary)
 *  - surface : neutral palette
 *
 * Le vert par défaut d'Aura ne fait pas partie de la charte — on l'élimine sur
 * les boutons "primary" en l'écrasant par l'or de la marque.
 */
import { definePreset } from '@primevue/themes'
import Aura from '@primevue/themes/aura'

export const PdmTheme = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#FAF7F2',
      100: '#F2EBDC',
      200: '#E5D6B9',
      300: '#D8C196',
      400: '#D1B578',
      500: '#C3A363',
      600: '#B39250',
      700: '#967A43',
      800: '#796236',
      900: '#5C4A29',
      950: '#3F331C',
    },
    colorScheme: {
      light: {
        primary: {
          color: '{primary.500}',
          contrastColor: '#ffffff',
          hoverColor: '{primary.600}',
          activeColor: '{primary.700}',
        },
        highlight: {
          background: '{primary.50}',
          focusBackground: '{primary.100}',
          color: '{primary.700}',
          focusColor: '{primary.800}',
        },
      },
    },
  },
})
